import RESTApiEndPoints from "./rest-api-end-points";
import ISearchRequest from "@/models/SearchRequest";
import axiosService from "@/services/axios-service";
import ICompartmentAssessmentReportResult from "@/models/msca/ICompartmentAssessmentReportResult";
import { ICompartmentAssessmentRequest } from "@/models/compartment-assessment-request";
import ICompartmentAssessment from "@/models/compartment-assessment.interface";

export default class CompartmentAssessmentService {
  public async add(obj: ICompartmentAssessmentRequest) {
    return (
      await axiosService.post<ICompartmentAssessment>(
        RESTApiEndPoints.compartmentAssessmentsUrl(),
        obj
      )
    )?.data;
  }
  public delete(obj: ICompartmentAssessment) {
    return axiosService.delete(`${RESTApiEndPoints.compartmentAssessmentsUrl()}/${obj.id}`);
  }

  public async lock(id: string, lock: boolean) {
    const command = lock ? "lock" : "unlock";
    return (
      await axiosService.put<ICompartmentAssessment>(
        `${RESTApiEndPoints.compartmentAssessmentsUrl()}/${command}`,
        {
          Id: id
        }
      )
    )?.data;
  }

  public Search(searchArgs: ISearchRequest) {
    return axiosService.post<ICompartmentAssessment[]>(
      `${RESTApiEndPoints.compartmentAssessmentsUrl()}/Search`,
      searchArgs
    );
  }

  public GetByShipId(shipId: number) {
    return axiosService.get<ICompartmentAssessment[]>(
      `${RESTApiEndPoints.compartmentAssessmentsUrl()}/GetByShipid/${shipId}`
    );
  }

  public GetOne(id: string) {
    return axiosService.get<ICompartmentAssessment>(
      `${RESTApiEndPoints.compartmentAssessmentsUrl()}/${id}`
    );
  }

  public getReport(id: string) {
    return axiosService.get<ICompartmentAssessmentReportResult>(
      `${RESTApiEndPoints.compartmentAssessmentsUrl()}/GetReport/${id}`
    );
  }

  public async DashBoardExcel(id: string) {
    return (
      await axiosService.get(`${RESTApiEndPoints.compartmentAssessmentsUrl()}/GetExcel/${id}`, {
        responseType: "blob"
      })
    ).data;
  }

  public async DashBoardPdf(id: string) {
    return (
      await axiosService.get(`${RESTApiEndPoints.compartmentAssessmentsUrl()}/GetPdf/${id}`, {
        responseType: "blob"
      })
    ).data;
  }
}
